import http from '../httpService';

const TermsOfUseService = {
  signTermsOfUseService: (userId, termId) => http.put(`terms-of-use/${termId}?userId=${userId}`),
};

export default TermsOfUseService;
